<template>
  <div class="wrapper">
    <password-reset-request-form
      :title="$t('app.help.forgotUsername')"
      :blurb="$t('app.help.forgotUsernameBlurb')"
      :input-field-default="$t('app.help.forgotUsernameDefault')"
      @forgot="handleUsernameRequest($event)"
    />
  </div>
</template>

<script>
import PasswordResetRequestForm from '@/app/components/PasswordResetRequestForm';
export default {
  components: {
    PasswordResetRequestForm
  },
  methods: {
    async handleUsernameRequest() {
      /**
       * TODO
       * make a call to api endpoint that handles forget username
       * request
       * Jira ticket TOL4-711
       */
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.wrapper {
  background-color: $white;
  padding: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
